import React from "react";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import ContainerFullHeight from "components/ContainerFullHeight/ContainerFullHeight";

import testimonials from "localDatabase/testimonials2025";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import i18next from "i18next";
import style from "./TestimonialsSectionStyle";
import TestimonialInfo from "components/TestimonialsInfo/TestimonialInfo";
import TestimonialInfoMobile from "components/TestimonialInfoMobile/TestimonialInfoMobile";

const useStyles = makeStyles(style);
const getCurrentLng = () =>
  i18next.language || window.localStorage.i18nextLng || "en";
const selectedLanguage = getCurrentLng();

export default function TestimonialsSection({ id, t }) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <ContainerFullHeight
      alignItems="start"
      id={id}
      bgColor="white"
      paddingTop="80px"
      paddingBottom="80px"
      justifyContent="center"
    >
      <div className={classes.container}>
        <GridContainer alignItems="stretch">
          {testimonials.map((testimonial, index) => (
            <GridItem xs={12} sm={12} md={6} lg={3} key={index}>
              {isMobile ? (
                <TestimonialInfoMobile testimonial={testimonial} />
              ) : (
                <TestimonialInfo testimonial={testimonial} />
              )}
            </GridItem>
          ))}
        </GridContainer>
      </div>
    </ContainerFullHeight>
  );
}
